import _ from "lodash";

export const emptyCreateFormData = () => ({
  title: "",
  form_category_id: null,
  form_sub_category_id: null,
  description: "",
});

export const createFormBuilderSnapshot = ({
  template = [],
  formData = null,
  templateFrom = null,
  selectedFormCategory = null,
  selectedFormSubCategory = null,
}) => ({
  template: _.cloneDeep(template),
  formData: formData ? _.cloneDeep(formData) : null,
  templateFrom: templateFrom ? _.cloneDeep(templateFrom) : null,
  selectedFormCategory: selectedFormCategory
    ? _.cloneDeep(selectedFormCategory)
    : null,
  selectedFormSubCategory: selectedFormSubCategory
    ? _.cloneDeep(selectedFormSubCategory)
    : null,
});

export const formBuilderSnapshotsEqual = (left, right) => {
  if (!left || !right) {
    return false;
  }

  return _.isEqual(left, right);
};
